import React, { Component } from 'react'
import { Col, Form, Input, Row, Select } from 'antd'
import { compose } from 'recompose'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import withSpinning from '../../../../elements/HOC/withSpinning'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withLoadingSection from '../../../../elements/HOC/withLoadingSection'
import withData from '../../../../elements/Select/withData'

const EmployeeSelect = compose(
  withUrlFetch({
    name: 'employees',
    url: 'employees/?status=Active',
    cache: true,
  }),
  withSpinning,
)(CustomSelect)

const Option = Select.Option

class NewGroup extends Component {
  render () {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }

    const { template, tags } = this.props
    const TagsSelect = compose(withData({ data: tags }))(CustomSelect)
    const groupTemplate = template ? template.members : []
    const formItems = groupTemplate.map(k => {
      return (
        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={k.value} key={k}>
              {getFieldDecorator(`group.project.members.${k.key}]`, {})(
                <EmployeeSelect
                  keyAtr={'_id'}
                  valueAtr={'name'}
                  placeholder={`Select an ${k.value} name`}
                />,
              )}
            </Form.Item>
          </Col>
        </Row>
      )
    })
    return (
      <div className="steps-content">
        <Row>
          <Col span={12}>
            <Form.Item label="Group Name" {...formItemLayout}>
              {getFieldDecorator('group.project.name', {
                rules: [
                  { required: true, message: 'Group Name can\'t be empty ' },
                ],
              })(<Input placeholder="Name"/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Project Type" {...formItemLayout}>
              {getFieldDecorator('group.project.tags', {
                rules: [
                  {
                    required: true,
                    message: 'Contract Type can\'t be empty ',
                  },
                ],
              })(<TagsSelect mode="multiple"/>)}
            </Form.Item>
          </Col>
        </Row>
        {formItems}
      </div>
    )
  }
}

export default compose(
  Form.create(),
  withLoadingSection,
)(NewGroup)
